import { render, staticRenderFns } from "./SendTextDialog.vue?vue&type=template&id=0ba6afce&"
import script from "./SendTextDialog.vue?vue&type=script&lang=js&"
export * from "./SendTextDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports